import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, HorizontalFlex, PadContainer, Input } from 'smartsuite-ui';
import DataPanel from './DataPanel';

function processRequest(result, request) {
    return {
        ...result,
        [request.metricSourceKey]: {
            metrics: [
                ...(result[request.metricSourceKey]?.metrics ?? []),
                ...(request.metrics ?? []),
            ],
            groupBy: [
                ...(result[request.metricSourceKey]?.groupBy ?? []),
                ...(request.groupBy ?? []),
            ],
        },
    };
}

function processView(view) {
    const metricSources =
        view.widgets
            ?.map((x) => x.metricRequests)
            .flat()
            .filter((x) => x)
            .reduce(processRequest, {}) ?? [];
    return { viewKey: view.viewKey, title: view.title, metricSources };
}

function processDashboard(config) {
    // prettier-ignore
    return window.location.pathname === '/Dashboard/Audit/'
        ? config.dashboardConfiguration?.map((x) =>
            x.configuration.views?.map(processView)
        ) ?? []
        : config.views?.map(processView) ?? [];
}

export default function GroupByDashboard(props) {
    const config =
        window.location.pathname === '/Dashboard/Audit/'
            ? props
            : props.dashboardConfiguration;
    let dashboardViews = processDashboard(config);
    if (window.location.pathname === '/Dashboard/Audit/') {
        const flattenedDashboardViews = dashboardViews.flatMap((x) => x);
        dashboardViews = flattenedDashboardViews;
    }
    const [expandAll, setExpandAll] = useState(false);
    const [inputText, setInputText] = useState('');

    function doesFilterMatch(metricSourceKey) {
        return (
            !inputText ||
            metricSourceKey.toLowerCase().includes(inputText.toLowerCase())
        );
    }

    return (
        <>
            <div className="bymetric">
                <HorizontalFlex cssClassModifiers={['space-between']}>
                    <div className="dummy" />
                    <div className="search-container">
                        <Input
                            value={inputText}
                            label="Search"
                            isClearable={true}
                            onChange={(newText) =>
                                setInputText(newText.target.value)
                            }
                        />
                    </div>
                </HorizontalFlex>

                <HorizontalFlex cssClassModifiers={['space-between']}>
                    <div className="dummy" />
                    <HorizontalFlex>
                        <Button
                            onClick={() => setExpandAll(true)}
                            disabled={expandAll}
                        >
                            Expand All
                        </Button>
                        <PadContainer cssClassModifiers={['pad-small']} />
                        <Button
                            onClick={() => setExpandAll(false)}
                            disabled={!expandAll}
                        >
                            Collapse All
                        </Button>
                    </HorizontalFlex>
                </HorizontalFlex>
            </div>
            <div className="bymetric">
                {dashboardViews.map((view) => (
                    <>
                        <HorizontalFlex cssClassModifiers={['space-between']}>
                            <h1>{`${view.title} - ${view.viewKey}`}</h1>
                        </HorizontalFlex>
                        <div className="content">
                            {Object.keys(view.metricSources)
                                .filter(doesFilterMatch)
                                .map((metricSourceKey) => (
                                    <>
                                        <PadContainer
                                            cssClassModifiers={['pad-medium']}
                                        />
                                        <DataPanel
                                            metricSourceKey={metricSourceKey}
                                            metricSource={
                                                view.metricSources[
                                                    metricSourceKey
                                                ]
                                            }
                                            expandAll={expandAll}
                                        />
                                    </>
                                ))}
                        </div>
                    </>
                ))}
            </div>
        </>
    );
}

GroupByDashboard.propTypes = {
    dashboardConfiguration: PropTypes.instanceOf(Object).isRequired,
};
